import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CurrencyLiraIcon(props: IconProps) {
    return <Icon {...props} iconKey={"currency_lira"}/>
}
